export const APP_HEADER_I18N = {
  theme: {
    lightMode: $localize`:@@shared.appHeader.theme.lightMode:ライトモード`,
    darkMode: $localize`:@@shared.appHeader.theme.darkMode:ダークモード`,
    systemSetting: $localize`:@@shared.appHeader.theme.systemSetting:システム設定`,
  },
} as const;
